module.exports = __webpack_public_path__ + "img/III-28.481ab29b.svg";